import Link from 'next/link';

interface IDealButtonProps {
  url: string,
  className?: string,
}

const DealButton = ({ url, className }: IDealButtonProps) => (
  <Link data-test="dealCardButton" href={ url } className={ className }>
    Deal Card
  </Link>
);

export default DealButton;
